define("settings/components/navigation-footer", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <section class="o--page__sidebarFooter">
    <ul class="o--page__sidebarList cNA--list u--m__lr__0">
      <li class="cNA--list__item cNA--list__item--footer">
        <LinkToExternal @model={{@slug}} @route="cluster.schedule.calendar" class="cNA--nav__link">
          {{svg-jar "calendar" class="o--icon--md cNA--list__icon"}}
          <span class="cNA--list__label at--onboardingSkippedProfileConnect__calendarLink">
            {{t "header.navigation.back_dashboard"}}
          </span>
        </LinkToExternal>
      </li>
  
      <li class="cNA--list__item cNA--list__item--footer">
        <Shared::Ui::Button
          @additional="block"
          @variant="unstyled"
          class="cNA--nav__link"
          {{on "click" (action @openChatbot "help")}}
        >
          {{svg-jar "help-solid" class="o--icon--md cNA--list__icon"}}
          <span class="cNA--list__label">
            {{t "header.about.support"}}
          </span>
        </Shared::Ui::Button>
      </li>
  
      <li class="cNA--list__item cNA--list__item--footer u--p__lr__sm u--clearfix">
        <Shared::AppFooter @dropTarget="e--footer__toggle" @logout={{action @logout}} />
  
      </li>
    </ul>
  </section>
  */
  {
    "id": "fWG9L0iG",
    "block": "[[[10,\"section\"],[14,0,\"o--page__sidebarFooter\"],[12],[1,\"\\n  \"],[10,\"ul\"],[14,0,\"o--page__sidebarList cNA--list u--m__lr__0\"],[12],[1,\"\\n    \"],[10,\"li\"],[14,0,\"cNA--list__item cNA--list__item--footer\"],[12],[1,\"\\n      \"],[8,[39,0],[[24,0,\"cNA--nav__link\"]],[[\"@model\",\"@route\"],[[30,1],\"cluster.schedule.calendar\"]],[[\"default\"],[[[[1,\"\\n        \"],[1,[28,[35,1],[\"calendar\"],[[\"class\"],[\"o--icon--md cNA--list__icon\"]]]],[1,\"\\n        \"],[10,1],[14,0,\"cNA--list__label at--onboardingSkippedProfileConnect__calendarLink\"],[12],[1,\"\\n          \"],[1,[28,[35,2],[\"header.navigation.back_dashboard\"],null]],[1,\"\\n        \"],[13],[1,\"\\n      \"]],[]]]]],[1,\"\\n    \"],[13],[1,\"\\n\\n    \"],[10,\"li\"],[14,0,\"cNA--list__item cNA--list__item--footer\"],[12],[1,\"\\n      \"],[8,[39,3],[[24,0,\"cNA--nav__link\"],[4,[38,4],[\"click\",[28,[37,5],[[30,0],[30,2],\"help\"],null]],null]],[[\"@additional\",\"@variant\"],[\"block\",\"unstyled\"]],[[\"default\"],[[[[1,\"\\n        \"],[1,[28,[35,1],[\"help-solid\"],[[\"class\"],[\"o--icon--md cNA--list__icon\"]]]],[1,\"\\n        \"],[10,1],[14,0,\"cNA--list__label\"],[12],[1,\"\\n          \"],[1,[28,[35,2],[\"header.about.support\"],null]],[1,\"\\n        \"],[13],[1,\"\\n      \"]],[]]]]],[1,\"\\n    \"],[13],[1,\"\\n\\n    \"],[10,\"li\"],[14,0,\"cNA--list__item cNA--list__item--footer u--p__lr__sm u--clearfix\"],[12],[1,\"\\n      \"],[8,[39,6],null,[[\"@dropTarget\",\"@logout\"],[\"e--footer__toggle\",[28,[37,5],[[30,0],[30,3]],null]]],null],[1,\"\\n\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[\"@slug\",\"@openChatbot\",\"@logout\"],false,[\"link-to-external\",\"svg-jar\",\"t\",\"shared/ui/button\",\"on\",\"action\",\"shared/app-footer\"]]",
    "moduleName": "settings/components/navigation-footer.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});